export const AWS_CONFIG =  window.AWSConfig;
